import styled, { device, color } from '@styled'

export const SectionWrapper = styled.section`
  padding-block-start: 30px;
  padding-block-end: 50px;
  ${device.medium} {
    padding-block-start: 40px;
    padding-block-end: 50px;
  }
  ${device.large} {
    padding-block-start: 60px;
    padding-block-end: 90px;
  }
  ${color}
  &:not(:last-child) {
    padding-block-end: 0;
  }
`

export const StyledText = styled.div`
  margin-block-start: 10px;
  margin-block-end: 20px;
  font-size: 18px;
  margin-inline-start: 34px;
  margin-inline-end: 34px;
  ul {
    list-style-type: disc;
    margin-left: 1em;
  }
  a {
    text-decoration: underline;
    &[href^='#'],
    :hover {
      text-decoration: none;
    }
  }
  h4,
  h5 {
    scroll-margin-top: 100px;
  }
`
